import React from 'react';
import './VaultCard.scss';
import Card from "@material-ui/core/Card";
import {navigate} from "@reach/router";
import {OWNER, purposeMapping} from "../../../config/constants";
import Tooltip from "@material-ui/core/Tooltip";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import moment from "moment";


function VaultCard(props) {

  const getVaultStatusIcon = () => {
    switch(props.vault.status) {
      case 'LOCKED':
        return <FontAwesomeIcon icon="lock" className="text-primary" size={"lg"}/>;
      case 'PENDING':
        return <FontAwesomeIcon icon="key" className="text-warning" size={"lg"}/>;
      case 'UNLOCKED':
        return <FontAwesomeIcon icon="lock-open" className="text-alert" size={"lg"}/>;
      case 'ARCHIVED':
        return <></>
        // return <FontAwesomeIcon icon="box" className="text-grey" size={"lg"}/>;
    }

  };

  const getVaultIcon = () => {
    let color, icon;
    switch(props.vault.status) {
      case 'LOCKED':
        color = "text-primary";
        break;
      case 'PENDING':
        color = "text-warning";
        break;
      case 'UNLOCKED':
        color = "text-alert";
        break;
      case 'ARCHIVED':
        color = "text-grey";
    }

    switch(props.vault.purpose) {
      case 'EMERGENCY':
        icon = "user-injured"; break;
      case 'MISSING':
        icon = "user-shield"; break;
      case 'STORAGE':
        icon = "folder-open"; break;
      case 'ESTATE_PLANNING':
        icon = "users"; break;
      case 'REAL_ESTATE':
        icon = "house-user"; break;
      case 'OTHER':
        icon = "shield-alt"; break;
    }
    return <FontAwesomeIcon icon={icon} className={color} size={"lg"}/>;

  };

  const lastUpdated = moment.duration(moment().diff(moment(props.vault.updated)));

  return (
    <div className={`relative vault-card-container mx-2 ${props.vault.status.toLowerCase()}`}>
      <div className="vault-icon-container">
        {getVaultIcon()}
      </div>
      <a className="full-size" onClick={() => navigate(`/vaults/${props.vault.id}`)}>
        <Card className="full-size vault-card">
          <div className="vault-header"/>
          <div className="vault-form-content-container">
            <div className="vault-title-container text-left font-bold">
              <Tooltip enterTouchDelay={50} title={props.vault.vault_name}>
                <span>{props.vault.vault_name}</span>
              </Tooltip>
            </div>
            {
              props.vault.role === OWNER ?
                <div className="vault-documents-text text-xs">{props.vault.number_documents} Document{props.vault.number_documents === 1 ? '' : 's'}</div>
                :
                <div className="vault-owner-name-text text-xs">{props.vault.owner_name}</div>
            }

            <div className="vault-type-text text-xs">{purposeMapping[props.vault.purpose]}</div>
            <div className="vault-updated-text text-xs text-grey">{ lastUpdated.humanize() } ago</div>
            <div className="vault-card-icon">
              {
                getVaultStatusIcon()
              }
            </div>
          </div>
        </Card>
      </a>
    </div>
  );
};

export default VaultCard;
